import { Fragment } from 'react';
import { When } from 'react-if';
import { type DisplayTextItems } from '../types';
import { DisplayTextViewItem, Space } from './DisplayTextItem';
export const SchoolInfoTextDisplay = ({
  displayItems
}: {
  displayItems: DisplayTextItems;
}) => {
  return <Fragment>
      <DisplayTextViewItem item={displayItems.schoolTypeId} data-sentry-element="DisplayTextViewItem" data-sentry-source-file="SchoolInfoTextDisplay.tsx" />
      <When condition={!!displayItems.gradeId} data-sentry-element="When" data-sentry-source-file="SchoolInfoTextDisplay.tsx">
        <Space data-sentry-element="Space" data-sentry-source-file="SchoolInfoTextDisplay.tsx" />
      </When>
      <DisplayTextViewItem item={displayItems.gradeId} data-sentry-element="DisplayTextViewItem" data-sentry-source-file="SchoolInfoTextDisplay.tsx" />
      {/* 학년 라벨이 -로 끝나지 않으면 공백 추가 */}
      <When condition={!displayItems.gradeId?.label?.endsWith('-') && !!displayItems.semesterId} data-sentry-element="When" data-sentry-source-file="SchoolInfoTextDisplay.tsx">
        <Space data-sentry-element="Space" data-sentry-source-file="SchoolInfoTextDisplay.tsx" />
      </When>
      <DisplayTextViewItem item={displayItems.semesterId} data-sentry-element="DisplayTextViewItem" data-sentry-source-file="SchoolInfoTextDisplay.tsx" />
    </Fragment>;
};